// extracted by mini-css-extract-plugin
export default {"wrapper":"vd","form":"wd","preference":"xd","request":"yd","job":"zd","smallprint":"Ad","asterisk":"Bd","success":"Cd","circle":"Dd"};